import { gsap } from "gsap";
import { Vue, Component, Watch } from "vue-property-decorator";

@Component
export default class DropdownAnimation extends Vue {
  isOpen = false;
  animationSpeed = 0.18;

  @Watch("isOpen")
  onisOpen(newValue: any) {
    this.$_dropdownAnimation_startDropdownAnimation(newValue);
  }

  mounted() {
    this.$_dropdownAnimation_initDropdownStyle();
  }

  $_dropdownAnimation_toggleState() {
    this.isOpen = !this.isOpen;
  }

  $_dropdownAnimation_initDropdownStyle() {
    const { targetElement, targetContentsElement } = this.$refs;

    gsap.set(targetElement, {
      maxHeight: 0
    });

    gsap.set(targetContentsElement, {
      autoAlpha: 0
    });
  }

  $_dropdownAnimation_shownDropdownAnimation(animationParams: any) {
    const {
      targetElement,
      targetContentsElement,
      animationSpeed
    } = animationParams;

    const targetContentsElementHeight = targetContentsElement.clientHeight;
    const shownAnimation = gsap.timeline();

    shownAnimation
      .to(targetElement, animationSpeed, {
        maxHeight: targetContentsElementHeight
      })
      .to(targetContentsElement, animationSpeed, {
        autoAlpha: 1
      });
  }

  $_dropdownAnimation_hiddenDropdownAnimation(animationParams: any) {
    const {
      targetElement,
      targetContentsElement,
      animationSpeed
    } = animationParams;

    const hiddenAnimation = gsap.timeline();

    hiddenAnimation
      .to(targetContentsElement, animationSpeed, {
        autoAlpha: 0
      })
      .to(targetElement, animationSpeed, {
        maxHeight: 0
      });
  }

  $_dropdownAnimation_startDropdownAnimation(openState: boolean) {
    const targetElement = this.$refs.targetElement;
    const targetContentsElement = this.$refs.targetContentsElement;
    const animationSpeed = this.animationSpeed;
    const paramsObj = {
      targetElement,
      targetContentsElement,
      animationSpeed
    };

    if (openState === true) {
      this.$_dropdownAnimation_shownDropdownAnimation(paramsObj);
    } else {
      this.$_dropdownAnimation_hiddenDropdownAnimation(paramsObj);
    }

    this.$_dropdownAnimation_startRotateAnimationOfArrowElement();
  }

  $_dropdownAnimation_startRotateAnimationOfArrowElement() {
    const isOpen = this.isOpen;
    const animationSpeed = this.animationSpeed;
    const arrowElement = this.$refs.arrowElement;
    if (!arrowElement) return false;

    gsap.to(arrowElement, animationSpeed, {
      rotate: isOpen ? -180 : 0
    });
    return true;
  }
}
